<template>
    <td :class="{ 'cell-edit':!this.disabled, 'text-white': this.bgColor}" :style="styles">
        <vx-tooltip :delay="tooltipDelay" :text="tooltipText" :tooltipPosition="tooltipPosition">
            <slot></slot>
        </vx-tooltip>
    </td>
</template>

<script>
export default {
  props:{
    bgColor:{
        type:String,
        required:false,
    },
    tooltipDelay:{
          type:String,
          default:'1.5s'
    },
    tooltipPosition:{
          type:String,
          default:'top'
    },
    tooltipText:{
        type:String,
        default:null
    },
    disabled:{
      default:false,
      type:Boolean
    },
    width:{
      type:String,
      default:''
    }
  },
  data: () => ({
    styles:{}
  }),
  mounted() {
    this.setStyles()
  },
  methods:{
    setStyles(){
      if(this.width != ''){
        this.styles={background:this.bgColor,width:this.width}
      }else{
        this.styles={background:this.bgColor}
      }
    }
  }
}
</script>

<style>

</style>